import React from 'react';

'use strict';

export default class RouteListener extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location && window.onLocationChanged)
            onLocationChanged(nextProps.location);
    }

    render() {
        return null;
    }
}